import React from 'react';
// import blackShoe from "../../../assets/icons/blackshoe.svg";
// import shoeIcon from "../../../assets/icons/shoe.svg";
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';
import { GiStrikingArrows } from "react-icons/gi";
import { GiSoccerBall } from "react-icons/gi";

const Card = ({ data }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className='flex flex-col m-3 h-max dark:border dark:border-white/[0.5] dark:text-white border-b border-slate-400 py-3 px-2 font-myanmarSansPro  text-sm'>
      <div className='bg-gradient-to-r from-waterThree via-waterThree to-waterTwo py-2 px-5 rounded-full'>
        <div className='flex justify-between items-center'>
          <div className='flex items-center'>
            {/* <span className="dark:hidden pr-3">
              <img src={blackShoe} alt="Black Shoe"></img>
            </span>
            <span className="hidden dark:block px-2">
              <img src={shoeIcon} alt='Shoe'></img>
            </span> */}
            {data.gamblingTypeId === 2 && <GiStrikingArrows size={18} className="mr-1 text-wback" />}
            {data.gamblingTypeId === 1 && <GiSoccerBall size={18} className="mr-1 text-wback" />}
            <h2 className='text-white dark:text-league_text font-bold ml-1'>{data?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
          </div>
          <p className="text-sm text-white font-dangrek">
            {
              moment(new Date(data?.createdDate)).format('DD.MM.YYYY h:mm A')
            }
          </p>
        </div>
      </div>
      {/* <div className='grid grid-cols-2 gap-4 pl-8 py-1 items-center'>
        <h4 className={`text-bg_header dark:text-white font-bold `}>BetID</h4>
        <p className=" dark:text-league_text text-sm cols-span-2 text-selectMatch">{data?.postingNo}</p>
      </div> */}
      <div className='grid grid-cols-2 gap-4 pl-8 py-1 pt-2 mt-2'>
        <h4 className='font-bold'>{t("betAmount")}</h4>
        <p className='font-dangrek'>{parseInt(data?.amount).toLocaleString()}</p>
      </div>
      {
        data?.gamblingTypeId === 2 ?
          <div className='grid grid-cols-2 gap-4 pl-8 py-1'>
            <h4 className='font-bold'>{t("teamCount")}</h4>
            <p className='font-dangrek'>{data?.teamCount}</p>
          </div>
          : null
      }
      <div className='grid grid-cols-2 gap-4 pl-8 py-1'>
        <h4 className='font-bold'>{t("profitAmount")}</h4>
        <p className='font-dangrek'>{data?.profitAmount < 0 ? "0" : parseInt(data?.profitAmount).toLocaleString()}</p>
      </div>

      <div className={`flex justify-end tracking-wider font-dangrek ${data?.status === `Win` ? 'text-win' : 'text-lose'}`}>
          {/* <TbArrowBadgeRightFilled size={21} /> */}
          <p className='font-extrabold mr-10'>
          {data?.status}
        </p>
      </div>
    </div>
  );
};

export default Card;
